import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

function TrustpilotHeroStars({ sx, ...props }) {
  return (
    <Box
      component='svg'
      viewBox='0 0 72 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      sx={{ display: 'block', flexShrink: 0, width: 72, height: 14, ...sx }}
      aria-hidden
      {...props}
    >
      <path
        d='M0 13.4281H13.4281V0H0V13.4281ZM14.5465 13.4281H27.9731V0H14.5449L14.5465 13.4281ZM29.0936 13.4281H42.5223V0H29.0925L29.0936 13.4281ZM43.6401 13.4281H57.0683V0H43.6391L43.6401 13.4281ZM58.1872 13.4281H71.6154V0H58.1861L58.1872 13.4281Z'
        fill='#2DA765'
      />
      <path
        d='M6.7119 9.05026L8.75426 8.53238L9.60803 11.1623L6.7119 9.05026ZM11.4101 5.64814H7.81516L6.71028 2.26221L5.60378 5.64814H2.00995L4.92011 7.74611L3.81524 11.131L6.72432 9.03298L8.51504 7.74611L11.4101 5.64814ZM21.26 9.05026L23.3024 8.53238L24.1562 11.1623L21.26 9.05026ZM25.9582 5.65138H22.3633L21.2584 2.26545L20.1541 5.64814H16.5613L19.4704 7.74719L18.3634 11.1326L21.2736 9.0346L23.0637 7.74774L25.9582 5.65138ZM35.8071 9.05026L37.8462 8.53292L38.7 11.1628L35.8071 9.05026ZM40.5053 5.65138H36.9104L35.8039 2.26545L34.7012 5.64814H31.1057L34.0159 7.74719L32.9099 11.1347L35.819 9.03676L37.6097 7.74989L40.5053 5.65138ZM50.3526 9.05026L52.3949 8.53238L53.2487 11.1623L50.3526 9.05026ZM55.0507 5.65138H51.4596L50.3536 2.26545L49.2488 5.64814H45.6544L48.5635 7.74719L47.4581 11.1347L50.3672 9.0373L52.1573 7.75043L55.0507 5.65138Z'
        fill='white'
      />
      <path
        d='M71.6142 0.000610352H64.9001V13.4288H71.6142V0.000610352Z'
        fill='#D2D4E0'
      />
      <path
        d='M64.9001 9.05084L66.9425 8.53296L67.7957 11.1618L64.9001 9.05084Z'
        fill='white'
      />
      <path
        d='M69.6005 5.65133H66.0056L64.9007 2.26648L63.7959 5.65133H60.2009L63.1111 7.74931L62.0062 11.1342L64.9153 9.03618L66.7055 7.74931L69.6005 5.65133Z'
        fill='white'
      />
    </Box>
  );
}

TrustpilotHeroStars.propTypes = {
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.array]),
};

export default TrustpilotHeroStars;
